<template>
  <div class="menu">
    <el-container class="header">
      <el-header>
        <div class="headerImg"><div class="img" :style="{backgroundImage: 'url(/static/image/logo.png)'}"></div></div>
        <div class="header_search">
          <el-breadcrumb separator-class="el-icon-arrow-right"  v-if="type === 'freeman'">
            <el-breadcrumb-item class="index"><span @click="toIndex()">首页</span></el-breadcrumb-item>
            <el-breadcrumb-item v-model="menu">{{ menu }}</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="sysUser">
            <el-dropdown :hide-on-click="false">
              <el-avatar icon="el-icon-user-solid" :size="40" style="margin-top: 5px"></el-avatar>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item ><span @click="toIndex">首页</span></el-dropdown-item >
                <el-dropdown-item>个人中心</el-dropdown-item>
                <el-dropdown-item divided> <span @click="logout">退出</span></el-dropdown-item >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>
    </el-container>
    <el-container class="menu-container" style="width: 100%; height: 915px; padding: 0" >
      <el-aside style="width: 11%; background-color: #35bac2">
        <el-row class="tac">
          <el-col :span="10" class="col">
            <el-menu background-color="#35bac2" class="el-menu-vertical-demo" text-color="#fff" active-text-color="#fff" :unique-opened=true >
              <template>
                <el-submenu v-for="(item, i) in menus" :index="i+1+''" :key="i">
                  <template slot="title">
                    <svg class="icon" aria-hidden="true"><use :xlink:href="item.icon"></use></svg>
                    <span class="menuName">{{ item.name }}</span>
                  </template>
                  <el-submenu v-for="(item1, i1) in item.childrenMenu" :index="i + '-' + i1+''" :key="i1" >
                    <template slot="title">
                       <svg class="icon" aria-hidden="true"><use :xlink:href="item1.icon"></use></svg>
                      <span  class="menuName" >{{ item1.name }}</span>
                    </template>
                    <el-menu-item v-for="(item2, i2) in item1.childrenMenu" :key="i2" @click="nav(item2.name), router(item2.url)">
                      {{ item2.name }}
                    </el-menu-item>
                  </el-submenu>
                </el-submenu>
              </template>
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-main><div class="main"><router-view></router-view></div></el-main>
    </el-container>
  </div>
</template>
<script>
import { Funds, OrderedList, GreenHouse, HamburgerButton,System} from "@icon-park/vue";
import {GLOBAL_URL} from '../../config/config.js'
import {logout} from '../../api/sys/login.js'
export default {
  inject:['reload'],
  components: {
    Funds,
    OrderedList,
    GreenHouse,
    HamburgerButton,
    System
  },
  name: "Menu",
  data() {
    return {
      editableTabsValue: "2",
      menus: "",
      menu: "",
      name: "",
      type: ""
    };
  },
  methods: {
    router(path) {
      this.$router.push({ path: path });
    },
    toIndex() {
      this.menu = "";
      this.$router.push({ path: "/index" });
    },
    nav(name) {
      this.menu = name;
    },
    logout() {
     logout();
      this.$router.push({ path: "/" });
    },
  },
  mounted(){
    let user = JSON.parse(sessionStorage.getItem("userInfo"))
    this.menus = user.menus;
    this.name = user.name;
    this.type = user.type;
  },
  created() {
  },
};
</script>
<style lang = "scss" scoped>
  .menu {
    width: 100%;
    height: 100%;
  }
  .menuName{
    margin-left: 6%
  }
  .el-breadcrumb{
    cursor: pointer;
    display: block;
    position: absolute;
    margin: 1% 10%;
    font-size: 0.3rem;

  }
  .el-breadcrumb  /deep/  .el-breadcrumb__inner
    {
      color: #fff !important;
    }
  .headerImg {
    width: 9.4%;
    height: 45%;
    float: left;
    margin: 0.6% 0.1%;
  }
  .img{
    width: 100%;
    height: 100%;
  }
  .is-vertical {
    width: 100%;
    height: 50px;
    background:#2E9AFE;
    background-image: linear-gradient(to right,#35bac2, #01DFD7);
    text-align: center;
  }

  .el-dropdown {
    float: right;
    line-height: 40px;
    color: black;
  }
  .el-dropdown .el-dropdown-link {
    cursor: pointer;
    color: black;
    font-size: 0.3rem;
    float: right;
  }
 .el-aside {
    height: 100%;
  }
  .el-menu{
    height: 867px;
  }
  .el-submenu i {
    float: left;
    margin: 9% auto;
  }
  .el-submenu span {
    float: left;
    color: #fff;
  }
  .el-menu-item {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: auto;
  }
  .el-submenu {
    width: 99%;
  }
  .allMain {
    width: 100%;
    height: 890;
    padding: 0;
  }
  .main {
    width: 100%;
    height: 100%;
    background: #f2f2f2;
  }
  .el-header {
    width: 100%;
  }
  .sysUser {
    float: right;
    width: 10%;
  }
  .menu-container {
    width: 100%;
    height: 800px;
  }
  .el-row {
    width: 100%;
  }
  .col {
    width: 100%;
  }
  .el-menu--inline {
    padding: 0;
  }
  .el-submenu .el-menu-item {
    height: 50px;
    line-height: 50px;
    padding: 0 45px;
    width: 30%;
    text-align: center;
  }
  .el-avatar{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue